import { TimeTrackingEntry } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { setActiveTimerAction, clearActiveTimerAction } from '../reducers/activeBillableTimerReducer';

export const useActiveBillableTimerActions = () => {

    const dispatch = useAppDispatch();

    const setActiveTimer = (timeEntry: TimeTrackingEntry) => {
        //console.log('timer started', timeEntry);
        dispatch(setActiveTimerAction(timeEntry));
    }

    const clearActiveTimer = () => {
        dispatch(clearActiveTimerAction());
    }

    return { setActiveTimer, clearActiveTimer };
}
